<div class="plus-icon-button">
  <svg-icon src="./assets/img/ic-add.svg" [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"></svg-icon>
</div>
